import {
    Cx,
} from 'tss-react'

import useLabel from 'app/hooks/useLabel'

import {
    ContainerAvailabilityForecastContainerStatuses,
} from 'app/enums/common.enums'
import {
    containerStatusLabelMap,
} from '../../ContainerAvailabilityForecast.utils'

export default function CustomTooltip({
    classes,
    cx,
    date,
    minPreconditioned,
    statuses,
}: Readonly<{
    classes: Record<string, string>,
    cx: Cx,
    date: string,
    minPreconditioned: number,
    statuses: Record<ContainerAvailabilityForecastContainerStatuses, number>,
}>) {
    const total = Object.values(statuses).reduce((acc, item) => {
        return item ? acc + item : acc
    }, 0)

    const l = useLabel()

    const {
        preconditioned,
        ...restStatuses
    } = statuses

    return (
        <div className={classes.tooltipWrapper}>
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('DATE')}</div>
                    <div>{date}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('TOTAL')}</div>
                    <div>{total}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('SAFE_MINIMUM_PRECON_STOCK')}</div>
                    <div>{minPreconditioned}</div>
                </div>
            </div>
            <div className={classes.wrapper}>
                {Object.entries(restStatuses).map(([
                    key,
                    value,
                ]) => {
                    return (Boolean(value) || value === 0) && (
                        <div
                            className={classes.item}
                            key={key}
                        >
                            <div className={classes.label}>
                                {l(containerStatusLabelMap[key] || key)}
                            </div>
                            <div className={classes.valueWrapper}>
                                <div
                                    data-testid={key}
                                    className={cx(classes.marker,
                                        value < 0 ? classes.error : classes?.[key])}
                                />
                                <div
                                    className={classes.value}
                                >
                                    {value}
                                </div>
                            </div>
                        </div>
                    )
                })}
                {(Boolean(preconditioned) || preconditioned === 0) && (
                    <div
                        className={classes.item}
                        key="preconditioned"
                    >
                        <div className={classes.label}>{l('PRECONDITIONED')}</div>
                        <div className={classes.valueWrapper}>
                            <div
                                data-testid="preconditioned"
                                className={cx(
                                    classes.marker,
                                    preconditioned < minPreconditioned
                                        ? classes.error
                                        : classes.preconditioned,
                                )}
                            />
                            <div
                                className={classes.value}
                            >
                                {preconditioned}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
